<template>
    <div>
        <el-form ref="form" :inline="true" :model="searcheModel">
            <el-form-item label="录单时间">
                <el-date-picker
                    size="small"
                    v-model="searcheModel.order_created_at"
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="财务审核">
                <el-select size="small" v-model="searcheModel.finance_audit" placeholder="请选择">
                    <el-option label="不限" value=""></el-option>
                    <el-option label="通过" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="屏蔽排课升级单">
                <el-select size="small" v-model="searcheModel.not_have_amount" placeholder="请选择">
                    <el-option label="不限" value=""></el-option>
                    <el-option label="是" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="small" @click="submitSearch" :loading="loading">搜索</el-button>
                <el-button @click="resetForm()" size="small" :loading="loading">重置</el-button>
                <ExportFile 
                url="/api/export/order-clue" 
                :params="searcheModel" 
                filename="订单线索分析" 
                buttonName="导出Excel">
                </ExportFile>
            </el-form-item>
        </el-form>
        <el-table 
        :data="list" 
        border 
        max-height="700" 
        :summary-method="getSummariesClue" 
        show-summary 
        :header-cell-style="{background: '#f3faff'}"
        class="tabTopBorder" 
        v-loading="loading" 
        key="6">
            <el-table-column prop="day_str" label="日期"></el-table-column>
            <el-table-column prop="6" sortable label="运营"></el-table-column>
            <el-table-column prop="3" sortable label="客户介绍"></el-table-column>
            <el-table-column prop="4" sortable label="展会"></el-table-column>
            <el-table-column prop="5" sortable label="项目招标"></el-table-column>
            <el-table-column prop="2" sortable label="网上搜索"></el-table-column>
            <el-table-column prop="sum_num" sortable label="来源合计"></el-table-column>
        </el-table>
    </div>
</template>
<script>
import OrderCount from "~/services/OrderCount";
import ExportFile from "~/widgets/ExportFile.vue";
import Config from "~/config/params";
export default{
    name: 'Clue',
    
    components: {
        ExportFile,
        Config,
    },

    data() {
        return {
            loading: false,
            list: [],
            searcheModel: {},
        };
    },

    created(){
        this.resetForm();
    },
    
    methods: {

        //重置按钮
        resetForm() {
            this.searcheModel = {
                order_created_at: Config.getDataTimes('to_day'),
                finance_audit: '1',
                sort_name: '',
                sort_by: '',
                not_have_amount: '',
            };
            this.list = [];
            this.submitSearch();
        },

        // 筛选查询
        submitSearch($data = null, collapse_name = null) {
            if($data && typeof $data.order !== undefined){
                this.searcheModel.sort_name = $data['prop'];
                this.searcheModel.sort_by = $data['order'];
            }
            let params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            this.getList(params);
        },

        //获取列表
        getList(params) {
            // loading 动画
            this.loading = true;
            OrderCount.getPayOrderCount(params, 'order-clue')
            .then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                this.loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        getSummariesClue(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                sums.push('共' + this.list.length + '条');
                return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                sums[index] = Math.round(values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!isNaN(value)) {
                    return prev + curr;
                    } else {
                    return prev;
                    }
                }, 0) * 100) / 100;
                } else {
                sums.push(0);
                }
            });
            return sums;
        },

        
    }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/count/payorder/clue.vue